import { useAtomValue } from "jotai";
import { colors } from "theme";

import { useVehicleConditionForm } from "pages/VehicleCondition/hooks/useVehicleConditionForm";

import Button from "components/Button";
import { DJVehicleConditionQuestion } from "components/DJVehicleConditionQuestion/DJVehicleConditionQuestion";
import { ListOfQuestions } from "components/DJVehicleConditionQuestion/types";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";
import TextInput from "components/TextInput";

import { clientConfigAtom } from "atoms/clientConfig";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useDigitalJourneyPageRouting } from "hooks/useDigitalJourneyPageRouting";
import { useEventTracking } from "hooks/useEventTracking";
import { getUserLocale } from "utils/locale/userLocale";

export const DJVehicleConditionsPage = () => {
  const { t } = useClientTranslation();
  const { trackEvent } = useEventTracking();
  const { onNext, continueCTA } = useDigitalJourneyPageRouting();
  const { locale } = useAtomValue(clientConfigAtom);
  const { handleSubmit, onType, isValid, warning, mileage } = useVehicleConditionForm(getUserLocale(locale));

  return (
    <PageLayout
      contentSpacing="space-between"
      as="form"
      onSubmit={handleSubmit(({ mileage }) => {
        trackEvent({ name: "Digital Journey - Vehicle condition", properties: { mileage } });
        onNext();
      })}
    >
      <Flex px={24} py={24} gap={16} flex={1} mb={16}>
        <Text as="h1" sizeVariant="xl" weight={600}>
          Condizioni del tuo veicolo a seguito del sinistro
        </Text>
        <Flex gap={48}>
          {(["isVehicleDrivable", "haveAirbagsDeployed"] as ListOfQuestions).map((variant) => (
            <DJVehicleConditionQuestion key={variant} variant={variant} />
          ))}
        </Flex>
        <Flex gap={24}>
          <TextInput
            name="mileage"
            value={mileage}
            label={<Text sizeVariant="lg">{t("vehicle_condition.mileage.question")}</Text>}
            onChange={onType}
            warning={warning}
            rightSection={
              <Text sizeVariant="md" mr={16} style={{ color: colors.grey[50] }}>
                {t("vehicle_condition.mileage.unit")}
              </Text>
            }
          />
        </Flex>
      </Flex>
      <Flex px={24} py={24} gap={16}>
        <Button disabled={!isValid} type="submit">
          {continueCTA}
        </Button>
      </Flex>
    </PageLayout>
  );
};
